import Helmet from "react-helmet";
import PropTypes from "prop-types";
import React, { Component } from "react";
import request from "superagent";
import { getTitleBase, getCorrectOffSalesRegion } from "../shared/util";
import DropDown from "./dropdown";
import "./dropdown.scss";
import "./market-update.scss";
import Magazine from "./magazine";

class MarketUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      currentMarket: "",
    };
    this.currentMarketUpdate = this.currentMarketUpdate.bind(this);
  }
  componentDidMount() {
    //Equestrian Sotheby's International Realty hardcoded since wellington is not a sales regions
    const urlPart =
      this.props.entity.officeId.toLowerCase() ===
        "c0c006f4-5237-4565-b90e-8411c757b966" &&
      this.props.entity.region.urlPart === "palmbeach"
        ? "wellington"
        : this.props.entity.region.urlPart;
    this.getMagazine(urlPart);
    this.setState({ currentMarket: urlPart });
  }

  currentMarketUpdate(urlPart) {
    //Equestrian Sotheby's International Realty hardcoded since wellington is not a sales regions
    const selectedUrlPart =
      this.props.entity.officeId.toLowerCase() ===
        "c0c006f4-5237-4565-b90e-8411c757b966" && urlPart === "wellington"
        ? "wellington"
        : urlPart;

    this.setState({ currentMarket: selectedUrlPart });
    this.getMagazine(selectedUrlPart);
  }

  getMagazine(urlPart) {
    request
      .post("/api/regions/magazine")
      .set("Content-Type", "application/json")
      .send({ urlPart: urlPart })
      .end((error, response) => {
        if (response && response.body) {
          this.setState({ data: response.body.magazines });
          window.scrollTo(0, 0);
        } else {
          console.error(error);
        }
      });
  }

  render() {
    const title = `Market Update Magazine - ${getTitleBase(this.props.entity)}`;

    return (
      <div className="market-update web-container container">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`View our market update magazine for luxury homes for sale in ${getCorrectOffSalesRegion(
              this.props.entity
            )} from ${this.props.entity.brand}.`}
          />
        </Helmet>
        <div className="page-header">
          <h3>Market Update </h3>
          <div className="header-separator"></div>
        </div>
        <div className="row">
          <div className="col-xs-16">
            <Magazine
              newMarketID={this.state.data.newMarketID}
              marketId={this.state.data.marketId}
              flipSnackId={this.state.data.flipSnackId}
              marketCode={this.state.data.marketCode}
              urlPart={this.state.currentMarket}
              officeId={this.props.entity.officeId}
            />
          </div>
        </div>

        <div className="btmspace">
          <DropDown key="1" currentMarketUpdate={this.currentMarketUpdate} />
        </div>
      </div>
    );
  }
}

MarketUpdate.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default MarketUpdate;



// WEBPACK FOOTER //
// ./src/components/market-update/index.js